import React from 'react';
import CompanyNewsComponent from "../../NewComponent/News";
import {GET_ALL_NEWS} from "../../../../../AdminPart/GraphQL/queries/workWithInformation";
import {useQuery} from "@apollo/client";

function QueryNewsAll (props) {
    const { loading, error, data} = useQuery(GET_ALL_NEWS);
    if (loading) return 'loading...';
    if (error) return `loading error! ${error.message}`;
    const getAllNewsForSort = [...data.getAllNews]

    return (
        <>
        <CompanyNewsComponent year={2020} ArrayOfAllNews={getAllNewsForSort.sort((a, b) => (a.NewsDate > b.NewsDate) ? -1 : 1)} lang={props.lang} PrerenderTexts = {props.PrerenderTexts}/>;
        </>
    )}
export default QueryNewsAll